<template>
  <div class="list-search">
    <div class="row">
      <input class="input" v-model="query" type="text" placeholder="חיפוש / הוספה" @focus="focused" @blur="blurred"/>
      <button class="round" @click="cancel" v-if="query">⨉</button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: "listSearch",
    computed: {
      ...mapState(['currentQuery']),
      query: {
        get () {
          return this.currentQuery
        },
        set (val) {
          this.setCurrentQuery(val)
        }
      }
    },
    methods: {
      ...mapActions(['setCurrentQuery', 'closeAppMenu']),
      focused () {
        this.closeAppMenu()
        window.scrollTo(0,0)
        this.$emit('focused')
      },
      blurred () {
        if (!this.currentQuery) {
          this.$emit('blurred')
        }
      },
      cancel () {
        this.setCurrentQuery('')
        this.$emit('blurred')
      }
    },
  }
</script>

<style scoped lang="sass">
  .list-search
    flex: 1
    transition: $transition-quick

  .round
    margin-right: $size-12
</style>
